// IFrameModal.tsx
import React from 'react';
import Box from '@mui/material/Box';
import Modal from 'src/components/Modal/TermsModal';

interface IFrameModalProps {
    title: string;
    src: string;
    isOpen: boolean;
    handleClose: () => void;
}

const IFrameModal = ({ title, src, isOpen, handleClose }: IFrameModalProps) => {
    return (
        <Modal title={title} handleClose={handleClose} isOpen={isOpen} width="100%">
            <Box>
                <iframe width="100%" height="500px" src={src} />
            </Box>
        </Modal>
    );
};

export default IFrameModal;
